module.exports = __webpack_public_path__ + "static/media/Lockton_Marine_P&I_britania.3562eca6.pdf";